import { render, staticRenderFns } from "./StepNew.vue?vue&type=template&id=34cacac2&scoped=true&"
import script from "./StepNew.vue?vue&type=script&lang=js&"
export * from "./StepNew.vue?vue&type=script&lang=js&"
import style0 from "./StepNew.vue?vue&type=style&index=0&id=34cacac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cacac2",
  null
  
)

export default component.exports